<template>
  <div>
    <v-app-bar app flat color="blue-grey lighten-5">
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="toggleDrawer" />

      <v-container class="mx-auto py-0">
        <v-row align="center">
          <v-img
            :src="require('../../assets/logo.png')"
            :lazy-src="require('../../assets/logo.png')"
            :max-width="$vuetify.breakpoint.smAndDown ? 70 : 85"
            class="mr-5"
            style="cursor: pointer;"
            @click="$vuetify.goTo(0)"
          />

          <v-btn
            text
            class="hidden-sm-and-down"
            @click="onClick($event, links[0])"
          >
            Home
          </v-btn>

          <v-menu
            class="elevation-0"
            offset-y
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">
                Gallery
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(category, index) in categories"
                v-bind:key="index"
                @click="openPictures(category)"
              >
                <v-list-item-title>{{
                  category.displayName
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            v-for="(link, i) in links"
            :key="i"
            v-bind="link"
            :class="{
              'hidden-sm-and-down': true,
              'hidden-md-and-up': link.text === 'Home',
            }"
            text
            @click="onClick($event, link)"
          >
            <span v-if="link.text !== 'Home'" v-text="link.text"></span>
          </v-btn>
        </v-row>
      </v-container>
    </v-app-bar>
    <GalleryDialog ref="galleryDialog" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "Nav",
  components: {
    GalleryDialog: () => import("@/components/gallery/GalleryDialog"),
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    ...mapMutations(["toggleDrawer"]),
    ...mapMutations("pictures", ["setActiveCategory"]),
    onClick(e, item) {
      e.stopPropagation();

      if (item.to || !item.href) return;

      this.$vuetify.goTo(item.href.endsWith("#") ? 0 : item.href);
    },
    openPictures(category) {
      this.setActiveCategory(category);
      this.$vuetify.goTo("#gallery");
    },
  },
  computed: {
    ...mapGetters("pictures", ["categories"]),
    ...mapState(["applicationName", "links"]),
  },
};
</script>
